// Un solo listener mousemove globale: aggiorna --mx/--my/--o sulle sole schede
// .ht-card visibili, dentro un requestAnimationFrame.
const RADIUS = 170;

let started = false;
let raf = 0;
let pointer = null;
const visible = new Set();
let observer = null;
let mutation = null;

const canHover = () =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const paint = () => {
  raf = 0;
  if (!pointer) {
    visible.forEach((el) => el.style.setProperty('--o', '0'));
    return;
  }
  visible.forEach((el) => {
    const r = el.getBoundingClientRect();
    const mx = pointer.x - r.left;
    const my = pointer.y - r.top;
    const dx = Math.max(r.left - pointer.x, 0, pointer.x - r.right);
    const dy = Math.max(r.top - pointer.y, 0, pointer.y - r.bottom);
    const dist = Math.hypot(dx, dy);
    const o = dist >= RADIUS ? 0 : 1 - dist / RADIUS;
    el.style.setProperty('--mx', mx + 'px');
    el.style.setProperty('--my', my + 'px');
    el.style.setProperty('--o', o.toFixed(3));
  });
};

const schedule = () => {
  if (!raf) raf = requestAnimationFrame(paint);
};

const onMove = (e) => {
  pointer = { x: e.clientX, y: e.clientY };
  schedule();
};

const onLeave = () => {
  pointer = null;
  schedule();
};

const sync = () => {
  if (!observer) return;
  document.querySelectorAll('.ht-card').forEach((el) => observer.observe(el));
};

export const startCardGlow = () => {
  if (started || typeof window === 'undefined' || !canHover()) return () => {};
  started = true;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visible.add(entry.target);
        } else {
          visible.delete(entry.target);
          entry.target.style.setProperty('--o', '0');
        }
      });
      schedule();
    },
    { rootMargin: '120px' }
  );

  sync();
  mutation = new MutationObserver(sync);
  mutation.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseleave', onLeave);
  window.addEventListener('blur', onLeave);

  return () => {
    window.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseleave', onLeave);
    window.removeEventListener('blur', onLeave);
    if (raf) cancelAnimationFrame(raf);
    if (observer) observer.disconnect();
    if (mutation) mutation.disconnect();
    visible.clear();
    observer = null;
    mutation = null;
    raf = 0;
    started = false;
  };
};

export default startCardGlow;
